import { useState, useEffect } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // 🔒 Lock body scroll when menu opens
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  // 🔥 Smooth scroll function
  const scrollToSection = (id) => {
    const section = document.getElementById(id);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="fixed top-0 w-full z-50">

      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-md transition-all duration-500 md:hidden ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setIsOpen(false)}
      />

      {/* Navbar */}
      <div className="bg-black/80 backdrop-blur-md shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-6 py-4">

          {/* Logo */}
          <img
            src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjUIdU1yxksRKlr-a5noiFUnKhzji-FfJw0xzlknZJOfYy9pIt4bdQzWZGWde_HeH8b-oVt2bR38RkRhlGZPWtyEj6C7jBZQl7wGMn2SxFXESxEnRbQAq2Dk32OrqHDA_MIv21iXahd0ggChsAxl4UK5qkDCBfBHQSFTpR0QCZTxw3CPNO90Qo9xn5A9qY/s320/Group%201.png"
            alt="Logo"
            className="h-10 md:h-12 object-contain"
          />

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8 text-gray-300 font-medium">
            <button onClick={() => scrollToSection("home")} className="hover:text-white transition">
              Home
            </button>

            <button onClick={() => scrollToSection("about")} className="hover:text-white transition">
              About
            </button>

            <button onClick={() => scrollToSection("services")} className="hover:text-white transition">
              Services
            </button>

            <button onClick={() => scrollToSection("products")} className="hover:text-white transition">
              Products
            </button>

            <button onClick={() => scrollToSection("featured")} className="hover:text-white transition">
              Featured
            </button>

            <button onClick={() => scrollToSection("contact")} className="hover:text-white transition">
              Contact
            </button>
          </div>

          {/* Desktop Button */}
          <button className="hidden md:block bg-white text-black px-5 py-2 rounded-full font-medium hover:bg-gray-200 transition">
            Book Appointment
          </button>

          {/* Mobile Button */}
          <button
            onClick={() => setIsOpen(true)}
            className="md:hidden text-white text-3xl"
          >
            ☰
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-black text-white z-50 transform transition-all duration-500 ease-in-out ${
          isOpen
            ? "translate-x-0 opacity-100 scale-100"
            : "translate-x-full opacity-0 scale-95"
        }`}
      >

        {/* Close Button */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-5 right-5 text-3xl hover:rotate-90 transition"
        >
          ✕
        </button>

        {/* Links */}
        <div className="flex flex-col gap-6 mt-24 px-6 text-lg font-medium">

          <button onClick={() => { scrollToSection("home"); setIsOpen(false); }}>
            Home
          </button>

          <button onClick={() => { scrollToSection("about"); setIsOpen(false); }}>
            About
          </button>

          <button onClick={() => { scrollToSection("services"); setIsOpen(false); }}>
            Services
          </button>

          <button onClick={() => { scrollToSection("products"); setIsOpen(false); }}>
            Products
          </button>

          <button onClick={() => { scrollToSection("featured"); setIsOpen(false); }}>
            Featured
          </button>

          <button onClick={() => { scrollToSection("contact"); setIsOpen(false); }}>
            Contact
          </button>

          <button className="mt-6 bg-white text-black px-5 py-3 rounded-full font-medium">
            Book Appointment
          </button>

        </div>
      </div>
    </div>
  );
};

export default Navbar;